import React, { useEffect, useState } from 'react'
import { ICompanyEmployee } from '../../types/company/ICompanyEmployee'
import Image from './Image'
import {Card, ListGroup} from 'react-bootstrap'
import EmployeeOperations from './EmployeeOperations'
import companyService from '../../api/company.api'
import Invite from './Invite'
import { useTranslation } from 'react-i18next';
import {useStores} from "../../stores";
import {VacancyCompanyHook} from "../../api/vacancy-company"; // Импортируем хук для перевода текста

const VacancyCompany = () => {
    const { t } = useTranslation(); // Используем хук для перевода текста

    const {authStore} = useStores()
    const companyId = authStore.user?.company?.id

    const {data, isLoading, refetch} = VacancyCompanyHook.useVacancyCompanies(companyId)
    const vacancyCompanyResponse = data && data[0]

    return <>
        <ListGroup className="flex flex-col gap-6">
            {vacancyCompanyResponse?.map((vacancyCompany) => (
                <Card key={vacancyCompany?.id} className="shadow-md rounded-2xl border border-gray-200">
                    <Card.Body className="p-6">
                        <div className="flex justify-between items-center mb-6">
                            <h3 className="text-xl font-bold text-gray-800">{vacancyCompany?.name}</h3>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6">
                            <div className="info-item-block">
                                <div className="text-base font-semibold text-gray-500">Отображаемое имя:</div>
                                <div className="text-lg text-gray-900">{vacancyCompany?.name}</div>
                            </div>

                            <div className="info-item-block">
                                <div className="text-base font-semibold text-gray-500">Описание:</div>
                                <div className="text-lg text-gray-900">{vacancyCompany?.description}</div>
                            </div>

                            <div className="info-item-block">
                                <div className="text-base font-semibold text-gray-500">Код:</div>
                                <div className="text-lg text-gray-900">{vacancyCompany?.code}</div>
                            </div>

                            <div className="info-item-block">
                                <div className="text-base font-semibold text-gray-500">БИН:</div>
                                <div className="text-lg text-gray-900">{vacancyCompany?.bin}</div>
                            </div>

                            <div className="info-item-block">
                                <div className="text-base font-semibold text-gray-500">Телефон:</div>
                                <div className="text-lg text-gray-900">{vacancyCompany?.phone}</div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            ))}
        </ListGroup>
    </>
}

export default VacancyCompany
